const { PRODUCT_LIST_GROUPING } = require('constants/content');
const { SHOW_PRICE, SHOW_RATING_WITH_TOTAL_COUNT, SHOW_LOVES_BUTON } = PRODUCT_LIST_GROUPING;

const CONSTRUCTOR_PODS = {
    YMAL: 'ymal-test',
    RFY: 'rfy-test',
    SIMILAR_PRODUCTS: 'similar-products-test',
    ATB: 'pdp-atb-modal',
    RFY_BASKET: 'basket-rfy',
    SELLING_FAST: 'hp-selling-fast',
    NEW_ARRIVALS: 'hp-new-arrivals',
    BESTSELLERS: 'bestsellers-content-page'
};

const CONTENT_CATEGORY = {
    MAKEUP: 'cat140006',
    SKINCARE: 'cat150006',
    FRAGRANCE: 'cat160006',
    BATH_BODY: 'cat140014',
    HAIR: 'cat130038',
    TOOL_BRUSHES: 'cat130042',
    MEN: 'cat130044'
};

const GROUPING = {
    YMAL: [SHOW_PRICE, SHOW_RATING_WITH_TOTAL_COUNT],
    ATB: [SHOW_PRICE, SHOW_RATING_WITH_TOTAL_COUNT, SHOW_LOVES_BUTON]
};

module.exports = {
    CONSTRUCTOR_PODS,
    GROUPING,
    CONTENT_CATEGORY
};
